import EntryPoint from '../views/entrypoint.vue'
import Login from '../views/login.vue'
import Scripts from '@/core/list/views/scripts.vue'
import Pass from '@/core/pass/views/pass.vue'

const routes = [
  {
    path: '/pipedrive/login',
    name: 'pipedriveLogin',
    component: Login,
  },
  {
    path: '/pipedrive',
    component: EntryPoint,
    children: [
      {
        path: '',
        name: 'pipedriveScripts',
        components: {core: Scripts},
      },
      {
        path: 'script/:id',
        name: 'pipedrivePass',
        components: {core: Pass},
      },
    ],
  },
]

export default routes
